import { useNavigate, useLocation } from 'react-router-dom';


export class SearchParamsKey {
  static readonly phone = 'phone'
  static readonly pin = 'pin'
  static readonly chatId = 'chatId'
  static readonly chatWithDanaId = 'chatWithDanaId'
}

export const useUrlParams = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const setUrlParam = (key: string, value: string | null) => {
    const params = new URLSearchParams(location.search);

    if (value === null) {
      params.delete(key);
    } else {
      params.set(key, value);
    }

    navigate({ search: params.toString() }, { replace: true });
  };

  const getUrlParam = (key: string): string | null => {
    const params = new URLSearchParams(location.search);
    return params.get(key);
  };

  const deleteUrlParam = (key: string) => {
    const params = new URLSearchParams(location.search);
    params.delete(key);
    navigate({ search: params.toString() }, { replace: true });
  };

  return { setUrlParam, getUrlParam, deleteUrlParam };
};